module.exports = __webpack_public_path__ + "img/income-statementTxt.70357098.png";